import { KEY_CODE } from './AudioPlayerConstants';

const { ENTER_CODE, SPACEBAR_CODE } = KEY_CODE;

export const addZeroBefore = value => `0${value}`.slice(-2);

export const formatTime = timeInSec => {
    if (timeInSec <= 0) {
        return '00:00';
    }

    if (timeInSec >= 60) {
        const minutes = Math.floor(timeInSec / 60);
        const seconds = timeInSec - minutes * 60;
        return `${addZeroBefore(minutes)}:${addZeroBefore(seconds)}`;
    }

    return `00:${addZeroBefore(Math.floor(timeInSec))}`;
};

export const getRangeBackgroundStyle = (separationPoint, unfilledColor, filledColor) =>
    `linear-gradient(to right, ${filledColor} 0%, ${filledColor} ${separationPoint}%, ${unfilledColor} ${separationPoint}%, ${unfilledColor} 100%)`;

export const handleKeyPress = (e, callBack) => {
    if (
        e.keyCode === SPACEBAR_CODE ||
        e.charCode === SPACEBAR_CODE ||
        e.keyCode === ENTER_CODE ||
        e.charCode === ENTER_CODE
    ) {
        e.preventDefault();
        callBack();
    }
};
